import { render, staticRenderFns } from "./ServicesBlock.vue?vue&type=template&id=1f590c32"
import script from "./ServicesBlock.vue?vue&type=script&lang=js"
export * from "./ServicesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports